<template>
    <b-modal v-model="localIsOpen" title="User Subscription Logs Details" hide-footer>
        <b-form-input v-model="searchQuery" placeholder="Search..." class="mb-3"></b-form-input>

        <div class="modal-body-scrollable">
            <div v-if="loading" class="text-center">
                <b-spinner></b-spinner>
            </div>
            <div v-else-if="filteredLogs.length">
                <b-table :items="paginatedLogs" :fields="getHeaders(userSubscriptionDetailLogs)" striped hover></b-table>
                <b-pagination v-model="currentPage" :total-rows="filteredLogs.length" :per-page="perPage" align="center" class="mt-3"></b-pagination>
            </div>
            <p v-else class="text-center text-muted">No Data Available</p>
        </div>

        <b-button variant="secondary" block @click="closeModal">Close</b-button>
    </b-modal>
</template>

<script>
import { GetUserSubscriptionDetailLogs } from "../../Helper/UserApiHelper";

export default {
    name: "CourseModal",
    props: {
        course: Object,
        isOpen: Boolean,
        tenantId: String,
    },
    data() {
        return {
            searchQuery: "",
            currentPage: 1,
            perPage: 10,
            loading: false,
            userSubscriptionDetailLogs: [],
            localIsOpen: this.isOpen
        };
    },
    computed: {
        filteredLogs() {
            if (!this.searchQuery) return this.userSubscriptionDetailLogs;
            return this.userSubscriptionDetailLogs.filter((log) =>
                Object.values(log).some(
                    (value) =>
                        value && value.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
                )
            );
        },
        paginatedLogs() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredLogs.slice(start, start + this.perPage);
        },
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.fetchUserLogs();
            }
            this.localIsOpen = newVal; // Sync prop with local state
        },
        localIsOpen(newVal) {
            if (newVal !== this.isOpen) {
                this.$emit("update:isOpen", newVal); // Emit event to sync parent state
            }
        },
    },
    methods: {
        async fetchUserLogs() {
    if (!this.course?.userSubscriptionID || !this.tenantId) {
        console.warn("Missing userSubscriptionID or tenantId", this.course, this.tenantId);
        return;
    }

    this.loading = true;
    try {
        const logsData = {
            UserSubscriptionID: this.course.userSubscriptionID,
            TenantID: this.tenantId,
        };
        console.log("Fetching logs with:", logsData);
        const userLogs = await GetUserSubscriptionDetailLogs(logsData);
        console.log("API Response:", userLogs);

        // Correctly assign only the logs array
        this.userSubscriptionDetailLogs = Array.isArray(userLogs.userSubscriptionsLogs) ? userLogs.userSubscriptionsLogs : [];
    } catch (error) {
        console.error("Error fetching user logs:", error);
        this.userSubscriptionDetailLogs = [];
    } finally {
        this.loading = false;
    }
},
        getHeaders(items) {
            if (!items.length) return [];
            return Object.keys(items[0]).map((key) => ({
                key,
                label: this.formatHeader(key),
            }));
        },
        formatHeader(key) {
            return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        },
        closeModal() {
            this.$emit("update:isOpen", false);
        },
    },
};
</script>


<style scoped>
.modal-body-scrollable {
    max-height: 400px;
    overflow-y: auto;
}
</style>
